export default {
  test: {
    loginUrl: 'http://ahtest.changyan.cn/home',
    serviceUrl:
      'http://ahtest.changyan.cn/EduResource/addons/library/sso/ssoservice.php',
    SSOServerUrlCenter: 'https://test-open.changyan.com/sso',
    SSOServerUrlLocal: 'http://ahtest.changyan.cn/sso',
    zpSession:'http://zhszpj.changyan.cn/archives/sso/service',
  },
  prod: {
    loginUrl: 'https://www.ahedu.cn/#/login',
    serviceUrl:
      'https://www.ahedu.cn/EduResource/addons/library/sso/ssoservice.php',
    SSOServerUrlCenter: 'https://open.changyan.com/sso',
    SSOServerUrlLocal: '//ah.sso.ahedu.cn/sso',
    zpSession:'https://zhszpj.ahedu.cn/archives/sso/service',
  },
};
